/**
 * 品牌支付配置入口
 */
import type { BrandPaymentConfig, ChapterConfig, PayPageConfig, SubscribePageConfig } from '../types'
import { superstoryPaymentConfig } from './superstory'
import { rocnovelPaymentConfig } from './rocnovel'
import { ocereadPaymentConfig } from './oceread'
import { talewavePaymentConfig } from './talewave'
import { ficmoonPaymentConfig } from './ficmoon'
import { novelarcPaymentConfig } from './novelarc'
import { storyellaPaymentConfig } from './storyella'
import { aurenovelPaymentConfig } from './aurenovel'
import { florastoryPaymentConfig } from './florastory'
import { novelsprigPaymentConfig } from './novelsprig'
import { silktalePaymentConfig } from './silktale'
import { pearlaPaymentConfig } from './pearla'
import { freeficPaymentConfig } from './freefic'
import { fictoraPaymentConfig } from './fictora'
import { marinovelPaymentConfig } from './marinovel'
import { flipnovelPaymentConfig } from './flipnovel'
import { moonpagePaymentConfig } from './moonpage'
import { storlynPaymentConfig } from './storlyn'
import { novarisPaymentConfig } from './novaris'
import { novelunePaymentConfig } from './novelune'
import { novelynPaymentConfig } from './novelyn'
import { novelmelloPaymentConfig } from './novelmello'
import { loadBrandConfig } from '@/utils/loadBrandConfig'

/**
 * 获取当前品牌的完整支付配置
 */
export function getPaymentConfig(): BrandPaymentConfig {
  return loadBrandConfig({
    superstory: superstoryPaymentConfig,
    rocnovel: rocnovelPaymentConfig,
    oceread: ocereadPaymentConfig,
    ficmoon: ficmoonPaymentConfig,
    storyella: storyellaPaymentConfig,
    aurenovel: aurenovelPaymentConfig,
    florastory: florastoryPaymentConfig,
    silktale: silktalePaymentConfig,
    freefic: freeficPaymentConfig,
    pearla: pearlaPaymentConfig,
    fictora: fictoraPaymentConfig,
    marinovel: marinovelPaymentConfig,
    talewave: talewavePaymentConfig,
    moonpage: moonpagePaymentConfig,
    novelune: novelunePaymentConfig,
    storlyn: storlynPaymentConfig,
    novaris: novarisPaymentConfig,
    novelyn: novelynPaymentConfig,
    flipnovel: flipnovelPaymentConfig,
    novelarc: novelarcPaymentConfig,
    novelsprig: novelsprigPaymentConfig,
    novelmello: novelmelloPaymentConfig,
  })
}

/**
 * 获取当前品牌的充值页面配置
 */
export function getPayPageConfig(): PayPageConfig {
  return getPaymentConfig().pay
}

/**
 * 获取当前品牌的订阅页面配置
 */
export function getSubscribePageConfig(): SubscribePageConfig {
  return getPaymentConfig().subscribe
}

/**
 * 获取当前品牌的阅读器弹窗配置
 */
export function getChapterConfig(): ChapterConfig {
  return getPaymentConfig().chapter
}

/**
 * 按场景加载配置的辅助函数
 * 用于组件内加载特定场景的品牌配置
 */
export function loadPaymentConfigByScene<T extends 'pay' | 'subscribe' | 'chapter'>(
  scene: T,
): T extends 'pay' ? PayPageConfig : T extends 'subscribe' ? SubscribePageConfig : ChapterConfig {
  const config = getPaymentConfig()
  return config[scene] as any
}
